import { render, staticRenderFns } from "./orderProfits.vue?vue&type=template&id=612065cf&"
import script from "./orderProfits.vue?vue&type=script&lang=js&"
export * from "./orderProfits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports